import { Component, OnInit } from '@angular/core';
import { ChatuserlistService } from '../chatuserlist/chatuserlist.service';
import { CookieService } from 'ngx-cookie-service';
import { CreateshopService } from '../createshop/createshop.service';

@Component({
  selector: 'app-chatuserlist',
  templateUrl: './chatuserlist.component.html',
  styleUrls: ['./chatuserlist.component.css']
})
export class ChatuserlistComponent implements OnInit {

  customerData: any;
  recentlists: any;
  shopkeeperTitle: any;

  data: any;
  cookieValue: any;

  constructor(private service: ChatuserlistService, private cookieService: CookieService, private craeteSHopService: CreateshopService) { }

  ngOnInit() {
    this.getShopData();
    this.getCustomerList();
  }

  getShopData() {
    this.cookieValue = this.cookieService.get("shop");

    if (this.cookieValue) {
      this.data = JSON.parse(this.cookieValue);

      var compData = {
        "companyid": this.data.companyid
      }

      this.craeteSHopService.getShopInfo(compData)
        .subscribe(shopData => {
          this.data = shopData;

          if (this.data.isSuccess == false) {
            console.log(this.data.message);
          }
          else {
            this.shopkeeperTitle = this.data.data.name;
          }
        });
    } else {
      this.shopkeeperTitle = "";
    }
  }

  getCustomerList() {
    var compData = {
      "companyid": "222"
    }

    this.service.getRecentCustomer(compData)
      .subscribe(data => {
        this.customerData = data;

        if (this.customerData.isSuccess == false) {
          console.log(this.customerData);
        }
        else {
          console.log("parin");
          this.recentlists = this.customerData.data;
          console.log(this.recentlists);
        }
      });
  }
}
